<template>
    <label
        class="textlabel eq-form-label"
        :class="[$attrs.class, showlabelontop ? 'd-flex flex-column flex-column-reverse' : '']"
        v-if="!smallonly"
        ><slot></slot><span v-if="text">{{ $tm(text) }}<TooltipHelp :text="tooltip" /></span>
        <div
            class="small opacity-50"
            v-if="subtext != undefined"
        >
            {{ $tm(subtext) }}
        </div>
    </label>
    <label
        class="eq-form-label-sm"
        :class="[$attrs.class, showlabelontop ? 'd-flex flex-column ' : '']"
        v-if="!largeonly"
        ><slot></slot><span v-if="text">{{ $tm(text) }}</span>
        <div
            class="small opacity-50"
            v-if="subtext != undefined"
        >
            {{ $tm(subtext) }}
        </div>
    </label>
</template>
<script setup lang="ts">
import { $tm } from '@/locize';
import { TooltipHelp } from '..';

withDefaults(
    defineProps<{
        /**
         * The text to display.
         */
        text?: string;

        /**
         * The subtext to display.
         */
        subtext?: string;

        /**
         * If true the label will only show on small screens.
         * @default false
         */
        smallonly?: boolean;

        /**
         * If true the label will only show on large screens.
         * @default false
         */
        largeonly?: boolean;

        /**
         * If true the label will show on top of the input.
         * @default false
         */
        showlabelontop?: boolean;

        /**
         * The tooltip text.
         */
        tooltip?: string;
    }>(),
    {
        smallonly: false,

        largeonly: false,

        showlabelontop: false,
    },
);
</script>
